import React, { useContext, useEffect, useState } from 'react';

import { ServiceResponse } from '../../../app/services/shared/interfaces';
import LazyLoading from '../../../components/LazyLoading';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { toast } from 'react-toastify';
import useTransferReasonService from '../../../app/services/hooks/useTransferReasonService';
import { TransferReason } from '../../../app/models/TransferReason';
import TransferReasonFormContainer from './TransferReasonFormContainer';

interface Props {
    transferReasonId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const TransferReasonEdit = ({ transferReasonId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {
        fetchingEditTransferReason,
        editTransferReason,
        fetchingUpdateTransferReason,
        updateTransferReason
    } = useTransferReasonService();

    const [transferReason, setTransferReason] = useState<TransferReason>({ name: '' });
    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        edit();
    }, []);

    const edit = () => {
        if (showLoading) showLoading('loading', 'Cargando banco...');
        editTransferReason(transferReasonId, {
            onSuccess: (response: ServiceResponse) => {
                setTransferReason(response.data.transfer_reason);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    };

    const update = () => {
        if (showLoading) showLoading('loading', 'Actualizando banco...');
        updateTransferReason(transferReasonId, transferReason, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return fetchingEditTransferReason ? (
        <LazyLoading height="300" />
    ) : (
        <TransferReasonFormContainer
            fetching={fetchingUpdateTransferReason}
            action={update}
            cancel={cancel}
            transferReason={transferReason}
            setTransferReason={setTransferReason}
            errorFields={errorFields}
        />
    );
};

export default TransferReasonEdit;
